import { render, staticRenderFns } from "./projectsTaskType.vue?vue&type=template&id=b61c75b0&"
import script from "./projectsTaskType.vue?vue&type=script&lang=js&"
export * from "./projectsTaskType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports